import {
  ADD_CART_ITEM,
  REMOVE_CART_ITEM,
  SET_CART_ITEMS,
  UPDATE_CART_ITEM,
} from "../actions/types";

const initialState = {
  items: [],
  itemsIds: {},
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CART_ITEMS: {
      let ids = action.data.reduce((acc, { item_id, _id }) => {
        acc[item_id] = {
          item_id: item_id,
          _id,
        };
        return acc;
      }, {});
      return {
        ...state,
        items: action.data,
        itemsIds: ids,
      };
    }
    case ADD_CART_ITEM: {
      return {
        ...state,
        items: [action.data, ...state.items],
        itemsIds: {
          ...state.itemsIds,
          [action.data.item_id]: {
            item_id: action.data.item_id,
            _id: action.data._id,
          },
        },
      };
    }
    case UPDATE_CART_ITEM: {
      let updatedItems = [...state.items];
      updatedItems[action.data.index] = {
        ...updatedItems[action.data.index],
        ...action.data.data,
      };
      return {
        ...state,
        items: updatedItems,
      };
    }
    case REMOVE_CART_ITEM: {
      let filteredItems = state.items.filter(
        ({ _id }) => _id !== action.data._id
      );
      let filteredItemsIds = { ...state.itemsIds };
      delete filteredItemsIds[action.data.item_id];
      return {
        ...state,
        items: filteredItems,
        itemsIds: filteredItemsIds,
      };
    }
    default:
      return state;
  }
};

export default cartReducer;
